<template>
    <div class="dynamic-content">
        <h1 class="page-title">Our Philosophy</h1>

        <div class="content-section compact-section">
            <p class="desc-text">On XigFor, every transaction is recorded toward your effective platform benefits.</p>
        </div>

        <div class="content-section compact-section">
            <p class="desc-text">XigFor does not sell fee discounts.</p>
            <p class="desc-text">It allows participation to reshape how platform services are paid for.</p>
            <p class="desc-text">Platform participation may result in eligibility-based service fee offsets or optional feature privileges.</p>
        </div>

        <div class="content-section compact-section">
            <p class="desc-text">Participation may result in eligibility-based service fee offsets through accumulated platform benefits and Credit Points, without altering the underlying platform service fee structure.</p>
        </div>

        <div class="content-section compact-section">
            <p class="desc-text">This approach aligns long-term participation with platform usage and reflects how platform services are settled, rather than offering direct price reductions or guaranteed outcomes.</p>
        </div>

        <div class="content-section overview-section">
            <h2 class="page-title">Program Overview</h2>

            <div class="compact-section">
                <p class="desc-text">The XigFor Growth Program is an optional participation program designed to enhance visibility, participation, and long-term engagement on the platform.</p>
            </div>

            <div class="compact-section">
                <p class="desc-text">Rather than competing on short-term price incentives or marketing fee reductions.</p>
                <p class="desc-text">The program focuses on building sustainable platform value through ongoing participation and buyer engagement.</p>
            </div>

            <div class="compact-section">
                <p class="desc-text">Participation in the Growth Program is voluntary</p>
                <p class="desc-text">and does not constitute an investment,</p>
                <p class="desc-text">revenue-sharing arrangement,</p>
                <p class="desc-text">commission program,</p>
                <p class="desc-text">or financial product of any kind.</p>
            </div>

            <div class="compact-section">
                <p class="desc-text">The Growth Program does not guarantee</p>
                <p class="desc-text">any specific outcome,</p>
                <p class="desc-text">financial return,</p>
                <p class="desc-text">income level,</p>
                <p class="desc-text">or service fee reduction.</p>
            </div>

            <div class="compact-section">
                <p class="desc-text">Rewards, if any, are promotional in nature,</p>
                <p class="desc-text">issued at the platform's discretion,</p>
                <p class="desc-text">and governed by the SmartRewards Terms.</p>
            </div>

            <div class="compact-section">
                <p class="desc-text">Program features, eligibility criteria,</p>
                <p class="desc-text">and participation mechanics</p>
                <p class="desc-text">may evolve over time</p>
                <p class="desc-text">based on platform development,</p>
                <p class="desc-text">policy updates,</p>
                <p class="desc-text">and applicable regulatory requirements.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GrowthProgramOverview'
}
</script>

<style scoped>
@import '../info/shared-info-styles.css';

.dynamic-content {
    max-width: 760px;
}

.page-title {
    margin-bottom: 18px;
    font-size: 40px;
    font-weight: 700;
    color: #393944;
}

.overview-section {
    margin-top: 10px;
}

.compact-section {
    margin-bottom: 18px;
}

.section-title {
    font-family: 'Poppins Light', sans-serif;
    font-size: 26px;
    font-weight: 300;
    line-height: 56px;
    color: #6c6c78;
    margin-top: 0;
    margin-bottom: 18px;
}

.desc-text {
    font-family: 'Poppins Light', sans-serif;
    font-size: 26px;
    font-weight: 300;
    line-height: 56px;
    color: #6c6c78;
    margin-bottom: 0;
}

@media (max-width: 900px) {
    .page-title {
        font-size: 20px;
        font-weight: 700;
        color: #393944;
        margin-bottom: 14px;
        line-height: 1.35;
    }

    .section-title {
        font-family: 'Poppins Light', sans-serif;
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: #6c6c78;
        margin-bottom: 14px;
    }

    .desc-text {
        font-family: 'Poppins Light', sans-serif;
        font-size: 10px;
        font-weight: 300;
        line-height: 20px;
        color: #6c6c78;
    }

    .compact-section {
        margin-bottom: 14px;
    }

    .overview-section {
        margin-top: 4px;
    }
}
</style>
